import React from "react";

import './App.css';
import './public/assets/css/style.min.css';
import './public/assets/css/bootstrap.min.css';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { FormDataProvider } from "./components/FormDataContext";
import AppointmentScreen from "./components/AppointmentScreen";
import ConfirmationScreen from "./components/ConfirmationScreen";
import LandingScreen from "./components/LandingScreen";
import VerificationScreen from "./components/verification/VerificationScreen";
import DetailsScreen from "./components/verification/DetailsScreen";
import CancelScreen from "./components/verification/CancelScreen";
import ConfirmScreen from "./components/verification/ConfirmScreen";
import RescheduleScreen from "./components/verification/RescheduleScreen";
import FeedbackScreen from "./components/feedback/FeedbackScreen";
import FeedbackGreetingScreen from './components/feedback/FeedbackGreetingScreen';
import FeedbackWithoutFeedbackScreen from './components/feedback/FeedbackWithoutFeedbackScreen';
import { ThemeProvider, createTheme } from "@mui/material/styles";


const theme = createTheme();

function App() {
  return (
    <ThemeProvider theme={theme}>
    <Router>
      <FormDataProvider>
        <div className="App">
          {/* <Navbar /> Uncomment if you have a Navbar */}
          <Routes>
            {/* LandingScreen for the root path */}
            {/* <Route path="/" element={<LandingScreen />} /> */}

            {/* Routes under /online-appointment */}
            <Route path="/online-appointment/*" element={<OnlineAppointmentRoutes />} />

            {/* Route for /customer-feedback */}
            <Route path="/*" element={<CustomerFeedbackRoutes />} />
          </Routes>
        </div>
      </FormDataProvider>
    </Router>
    </ThemeProvider>
  );
}

function OnlineAppointmentRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingScreen />} />
      <Route path="/ticket-schedule" element={<AppointmentScreen />} />
      <Route path="/ticket-confirmation" element={<ConfirmationScreen />} />
      <Route path="/verification" element={<VerificationScreen />} />
      <Route path="/ticket-details" element={<DetailsScreen />} />
      <Route path="/cancel-appointment" element={<CancelScreen />} />
      <Route path="/cancellation" element={<ConfirmScreen />} />
      <Route path="/reschedule" element={<RescheduleScreen />} />
    </Routes>
  );
}

function CustomerFeedbackRoutes() {
  return (
    <Routes>
      <Route path="/" element={<FeedbackScreen />} />
      <Route path="/thank-you" element={<FeedbackGreetingScreen />} />
      <Route path="/thank" element={<FeedbackWithoutFeedbackScreen />} />
    </Routes>
  );
}

export default App;
